import { Component, type ErrorInfo, type ReactNode } from 'react';
import { Button } from '@/components/ui/Button';
import i18n from '@/lib/i18n';
import { TYPE } from '@/lib/typography';
import { cn } from '@/utils/cn';

interface AppErrorBoundaryState {
  hasError: boolean;
}

export class AppErrorBoundary extends Component<{ children: ReactNode }, AppErrorBoundaryState> {
  state: AppErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): AppErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('app: uncaught render error', error, info.componentStack);
  }

  render(): ReactNode {
    if (!this.state.hasError) return this.props.children;

    return (
      <div className="flex min-h-screen flex-col items-center justify-center bg-ds-bg px-4">
        <h1 className={cn(TYPE.title, 'text-ds-text')}>{i18n.t('app.error_generic')}</h1>
        <p className={cn(TYPE.body, 'mt-4 max-w-md text-center text-ds-muted')}>
          {i18n.t('app.crash_body', 'Genindlæs siden for at fortsætte.')}
        </p>
        <div className="mt-8">
          <Button type="button" onClick={() => window.location.reload()}>
            {i18n.t('app.reload', 'Genindlæs')}
          </Button>
        </div>
      </div>
    );
  }
}
